module.exports = __webpack_public_path__ + "img/woman-phone.7bf248c2.svg";